module.exports = __webpack_public_path__ + "media/images/solicitud/prestador-b7b9c1ebda43d88c164b7f4e2b4db7fb.svg";